import React from 'react';
import moment from 'moment';
import { faStopwatch } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    Button,
    Input,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
} from 'reactstrap';

const hours = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'];
const minutes = ['00', '15', '30', '45'];
const antemeridians = ['AM', 'PM'];

export default class ConstrainedTimeInput extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showModal: false,
            hour: '12',
            minute: '00',
            antemeridian: 'AM',
            fineTuneActive: false,
        };
    }

    getValueParts = (value) => {
        const parsed = moment(value, ['HH:mm', 'H:mm'], true);

        if (!value || !parsed.isValid()) {
            return {
                hour: '12',
                minute: '00',
                antemeridian: 'AM',
            };
        }

        return {
            hour: parsed.format('h'),
            minute: parsed.format('mm'),
            antemeridian: parsed.format('A'),
        };
    };

    getDisplayValue = (value) => {
        const parsed = moment(value, ['HH:mm', 'H:mm'], true);

        if (!value || !parsed.isValid()) {
            return '';
        }

        return parsed.format('h:mm A');
    };

    openModal = () => {
        const { disabled, readOnly, value } = this.props;

        const { fineTuneActive } = this.state;

        if (disabled || readOnly || fineTuneActive) {
            return;
        }

        const parts = this.getValueParts(value);

        this.setState({
            showModal: true,
            ...parts,
        });
    };

    onTimeInputClick = (e) => {
        e.preventDefault();
        this.openModal();
    };

    onTimeInputTouchStart = (e) => {
        e.preventDefault();
        this.openModal();
    };

    closeModal = () => {
        this.setState({ showModal: false });
    };

    onBlur = () => {
        this.setState({ fineTuneActive: false });
    };

    onTimePartChanged = (e) => {
        const { name, value } = e.target;

        this.setState({ [name]: value });
    };

    onSaveModalTime = () => {
        const { name, onChange } = this.props;
        const { hour, minute, antemeridian } = this.state;

        const parsed = moment(
            `${hour}:${minute} ${antemeridian}`,
            'h:mm A',
            true
        );
        const value = parsed.isValid() ? parsed.format('HH:mm') : '';

        this.closeModal();

        onChange({
            target: {
                name,
                value,
                type: 'time',
            },
        });
    };

    onTimeChanged = (e) => {
        const { name, onChange } = this.props;

        onChange({
            target: {
                name,
                value: e.target.value,
                type: 'time',
            },
        });
    };

    onFineTuneButtonClick = () => {
        const { disabled, readOnly } = this.props;

        if (disabled || readOnly) {
            return;
        }

        this.setState({ fineTuneActive: true });
    };

    render() {
        const {
            id,
            required,
            value,
            invalid,
            disabled,
            readOnly,
            name,
            hideFineTune,
            bsSize,
            ...inputProps
        } = this.props;

        const { showModal, hour, minute, antemeridian, fineTuneActive } =
            this.state;

        return (
            <>
                <div className="d-flex flex-row constrained-time-input">
                    <Input
                        {...inputProps}
                        id={id}
                        required={required}
                        type="time"
                        name={name}
                        value={value}
                        onClick={this.onTimeInputClick}
                        onTouchStart={this.onTimeInputTouchStart}
                        onChange={this.onTimeChanged}
                        onBlur={this.onBlur}
                        disabled={disabled}
                        invalid={invalid}
                        readOnly={fineTuneActive ? readOnly : true}
                        placeholder="Select time"
                        autoFocus={fineTuneActive}
                    />
                    {!disabled && !readOnly && !hideFineTune && (
                        <Button
                            type="button"
                            color="primary"
                            className="ml-2"
                            onClick={this.onFineTuneButtonClick}
                            disabled={disabled || readOnly}
                            outline={!fineTuneActive}
                            aria-label="Click to adjust time precisely"
                            size={bsSize}
                        >
                            <FontAwesomeIcon icon={faStopwatch} />
                        </Button>
                    )}
                </div>

                <Modal
                    isOpen={showModal}
                    toggle={this.closeModal}
                    fade={false}
                    autoFocus={false}
                >
                    <ModalHeader toggle={this.closeModal}>
                        Select Start Time
                    </ModalHeader>
                    <ModalBody>
                        <div className="d-flex flex-row">
                            <Input
                                type="select"
                                name="hour"
                                value={hour}
                                onChange={this.onTimePartChanged}
                                className="mr-2"
                                autoFocus={true}
                            >
                                {hours.map((h) => (
                                    <option key={h} value={h}>
                                        {h}
                                    </option>
                                ))}
                            </Input>
                            <Input
                                type="select"
                                name="minute"
                                value={minute}
                                onChange={this.onTimePartChanged}
                                className="mr-2"
                            >
                                {minutes.map((m) => (
                                    <option key={m} value={m}>
                                        {m}
                                    </option>
                                ))}
                            </Input>
                            <Input
                                type="select"
                                name="antemeridian"
                                value={antemeridian}
                                onChange={this.onTimePartChanged}
                            >
                                {antemeridians.map((a) => (
                                    <option key={a} value={a}>
                                        {a}
                                    </option>
                                ))}
                            </Input>
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={this.closeModal}>
                            Cancel
                        </Button>
                        <Button color="primary" onClick={this.onSaveModalTime}>
                            Save
                        </Button>
                    </ModalFooter>
                </Modal>
            </>
        );
    }
}
